var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useMemo } from 'react';
export var BannerMessageType;
(function (BannerMessageType) {
    BannerMessageType[BannerMessageType["Warning"] = 0] = "Warning";
    BannerMessageType[BannerMessageType["Success"] = 1] = "Success";
    BannerMessageType[BannerMessageType["Error"] = 2] = "Error";
})(BannerMessageType || (BannerMessageType = {}));
export var BannerIconType;
(function (BannerIconType) {
    BannerIconType[BannerIconType["Error"] = 0] = "Error";
    BannerIconType[BannerIconType["Success"] = 1] = "Success";
})(BannerIconType || (BannerIconType = {}));
var BannerContext = createContext(undefined);
export var useBanner = function () {
    var context = useContext(BannerContext);
    if (!context)
        throw new Error('useBanner must be used within a BannerProvider');
    return context;
};
export function BannerProvider(_a) {
    var children = _a.children;
    var _b = useState(''), bannerMessage = _b[0], setBannerMessage = _b[1];
    var _c = useState(BannerMessageType.Warning), bannerType = _c[0], setBannerType = _c[1];
    var _d = useState(BannerIconType.Error), bannerIcon = _d[0], setBannerIcon = _d[1];
    var _e = useState(false), showBanner = _e[0], setShowBanner = _e[1];
    var _f = useState(false), isRefreshEnabled = _f[0], setIsRefreshEnabled = _f[1];
    var value = useMemo(function () { return ({
        bannerMessage: bannerMessage,
        setBannerMessage: setBannerMessage,
        bannerType: bannerType,
        setBannerType: setBannerType,
        bannerIcon: bannerIcon,
        setBannerIcon: setBannerIcon,
        showBanner: showBanner,
        setShowBanner: setShowBanner,
        isRefreshEnabled: isRefreshEnabled,
        setIsRefreshEnabled: setIsRefreshEnabled,
    }); }, [bannerMessage, bannerType, bannerIcon, showBanner, isRefreshEnabled]);
    return _jsx(BannerContext.Provider, __assign({ value: value }, { children: children }));
}
